export var getAdditionalInfoVal = function (additionalInfo, key) {
    var _a;
    if ((additionalInfo === null || additionalInfo === void 0 ? void 0 : additionalInfo.length) === 0 || !additionalInfo)
        return null;
    return ((_a = additionalInfo === null || additionalInfo === void 0 ? void 0 : additionalInfo.find(function (i) { return (i === null || i === void 0 ? void 0 : i.name) === key; })) === null || _a === void 0 ? void 0 : _a.value) || null;
};
//# sourceMappingURL=getAdditionalInfoVal.js.mapexport var getAdditionalInfoVal = function (additionalInfo, key) {
    var _a;
    if ((additionalInfo === null || additionalInfo === void 0 ? void 0 : additionalInfo.length) === 0 || !additionalInfo)
        return null;
    return ((_a = additionalInfo === null || additionalInfo === void 0 ? void 0 : additionalInfo.find(function (i) { return (i === null || i === void 0 ? void 0 : i.name) === key; })) === null || _a === void 0 ? void 0 : _a.value) || null;
};
//# sourceMappingURL=getAdditionalInfoVal.js.map